// import React from 'react'
// import CustomerPersonContainer from './views/admin/CustomerPersonContainer'
import CustomerPersonSearchContainer from './views/admin/CustomerPersonBoxContainer'
import CustomerUserContainer from './views/admin/CustomerUserContainer'
import CustomerOrganisationContainer from './views/admin/CustomerOrganisationSearchContainer'
import AdminCourtsContainer from './views/admin/CourtsContainer'
import CashierCourtsContainer from './views/cashiers/CourtsContainer'
import MainContainer from './views/cashiers/MainContainer'
import PersonsContrainer from './views/cashiers/PersonsContrainer'
import ResourcesContainer from './views/admin/ResourcesContainer'
import ActivitiesContainer from './views/admin/ActivitiesContainer'
import ActivitiesCalendarContainer from './views/admin/ActivitiesCalendarContainer'
import ActivityTemplatesContainer from './views/admin/ActivityTemplatesContainer'
import RecurringActivitiesContainer from './views/admin/RecurringActivitiesContainer'
import MembershipsContainer from './views/admin/MembershipsContainer'
import ContractsContainer from './views/admin/ContractsContainer'
import ContractTemplatesContainer from './views/admin/ContractTemplatesContainer.jsx'
import RecurringInquiriesContainer from './views/admin/RecurringInquiriesContainer.jsx'
import InquiriesContainer from './views/admin/InquiriesContainer.jsx'
import TeamSeasonCalendarContainer from './views/admin/TeamSeasonCalendarContainer'
import TeamFormatsContainer from './views/admin/TeamFormatsContainer'
import TeamsContainer from './views/admin/TeamsContainer'
import TeamTiesContainer from './views/admin/TeamTiesContainer'

import ConfigOpeningTimes from './views/admin/ConfigOpeningTimes'
import ConfigResourceCategoriesContainer from './views/admin/ConfigResourceCategoriesContainer'
import ConfigSportsAndActivityTypes from './views/admin/ConfigSportsAndActivityTypes'
// import ConfigResourceConfigsContainer from './views/admin/ConfigResourceConfigsContainer'
import ConfigColorsContainer from './views/admin/ConfigColorsContainer'
import ConfigInfoTexts from './views/admin/ConfigInfoTexts'
import ConfigTerms from './views/admin/ConfigTerms'

import PricingCalendarContainer from './views/admin/PricingCalendarContainer'
import CustomerTimesCalendarContainer from './views/admin/CustomerTimesCalendarContainer'
import MembershipPricingCalendarContainer from './views/admin/MembershipPricingCalendarContainer'
import GiftcodePricingCalendarContainer from './views/admin/GiftcodePricingCalendarContainer'
// import ShareholderCalendarContainer from './views/admin/ShareholderCalendarContainer'
import ShareRegistryContainer from './views/admin/ShareRegistryContainer'
import ShareRegistrySettingsContainer from './views/admin/ShareRegistrySettingsContainer'
import ShareRegistryTransactionsContainer from './views/admin/ShareRegistryTransactionsContainer'
import RecurrentCourtsContainer from './views/admin/RecurrentCourtsContainer'
import InvoicingContainer from './views/admin/InvoicingContainer'
import InvoicesContainer from './views/admin/InvoicesContainer'
import UnpaidContainer from './views/cashiers/UnpaidContainer'
import Logout from './views/Logout.jsx'
// import ConfigCustomerExtradata from './components/Config/CustomerExtradata'

// import NotInDemoContainer from './views/admin/NotInDemoContainer'
import ReportingContainer from './views/admin/ReportingContainer'
import WeeklySummaryContainer from './views/admin/WeeklySummaryContainer'
import MonthlySummaryContainer from './views/admin/MonthlySummaryContainer'
import ConfigMessageTemplates from './views/admin/ConfigMessageTemplates'
import GiftcodeContainer from './views/admin/GiftcodeContainer'
import ReservationExtrasContainer from './views/admin/ReservationExtrasContainer'
import MediaLibraryContainer from './views/admin/MediaLibraryContainer'
import BannersContainer from './views/admin/BannersContainer'
import TextBannersContainer from './views/admin/TextBannersContainer'
import ConfigRecurringContractTerms from './views/admin/ConfigRecurringContractTerms'
// import ConfigReminderTemplates from './views/admin/ConfigReminderTemplates'

//import AutomationMarketingContainer from './views/admin/AutomationMarketingContainer'

import BenefitCardsContainer from './views/admin/BenefitCardsContainer.jsx'
import BenefitCardListsContainer from './views/admin/BenefitCardListsContainer.jsx'
import MembershipListContainer from './views/admin/MembershipListContainer.jsx'

import ConfigCustomerViewability from './views/admin/ConfigCustomerViewability'

/*
import ShopContainer from './views/admin/ShopContainer'
import ProductsContainer from './views/admin/ProductsContainer'
import PartnerContainer from './views/admin/PartnerContainer'
import DevHistory from './views/admin/DevHistory'
import { BACKEND_RELEASES, RELEASE_HISTORY, MOBILE_RELEASES } from './readme'
*/
import TBDContainer from './views/admin/TBDContainer'
import LightsForce from './views/admin/LightsForce'
import SimplePosContainer from './views/admin/SimplePosContainer'
/*
import CustomersLiveContainer from './views/admin/CustomersLiveContainer'
import ConfigDash from './views/admin/ConfigDash'
import AdminCourtsDNDContainer from './views/admin/CourtsDNDContainer'
import UsersContainer from './views/admin/UsersContainer'
*/

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import RepeatIcon from '@mui/icons-material/Repeat'
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import GavelIcon from '@mui/icons-material/Gavel'
import EuroIcon from '@mui/icons-material/Euro'
import NewReleasesIcon from '@mui/icons-material/NewReleases'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import DateRangeIcon from '@mui/icons-material/DateRange'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import DoneIcon from '@mui/icons-material/Done'
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash'
import FontDownloadIcon from '@mui/icons-material/FontDownload'
import TodayIcon from '@mui/icons-material/Today'
import ScheduleIcon from '@mui/icons-material/Schedule'
import BuildIcon from '@mui/icons-material/Build'
import TuneIcon from '@mui/icons-material/Tune'
import ApartmentIcon from '@mui/icons-material/Apartment'
import GroupsIcon from '@mui/icons-material/Groups'
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'

import ProvidersContainer from './views/admin/ProvidersContainer.jsx'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import ShopProductsContainer from './views/admin/ShopProductsContainer.jsx'
import ProshopContainer from './components/Proshop/ProshopContainer.jsx'
import ProshopOrdersContainer from './components/Proshop/ProshopOrdersContainer.jsx'
import RecurringSalesContainer from './views/admin/RecurringSalesContainer.jsx'
import RecurringSalePricingCalendarContainer from './views/admin/RecurringSalePricingCalendarContainer.jsx'
// import MembershipListsContainer from './views/admin/MembershipListsContainer.jsx'
import KeyboardIcon from '@mui/icons-material/Keyboard'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import BuildingMaintenanceContainer from './views/admin/BuildingMaintenanceContainer.jsx'
import ReservationBenefitCardsContainer from './views/admin/ReservationBenefitCardsContainer.jsx'
import ValueCardsContainer from './views/admin/ValueCardsContainer.jsx'
import ReservationBenefitCardCalendarContainer from './views/admin/ReservationBenefitCardCalendarContainer.jsx'
import BuildingMaintenanceAdminContainer from './components/Partners/BuildingMaintenanceAdminContainer.jsx'
import BuildingMaintenanceProductsContainer from './components/Partners/BuildingMaintenanceProductsContainer.jsx'
import BuildingMaintenanceTicketsContainer from './components/Maintenance/BuildingMaintenanceTicketsContainer.jsx'
import BuildingMaintenancePlanContainer from './components/Maintenance/BuildingMaintenancePlanContainer.jsx'
import BuildingMaintenanceTicketsSettingsContainer from './components/Maintenance/BuildingMaintenanceTicketsSettingsContainer.jsx'
import TarmoIcon from './components/Partners/TarmoIcon.js'
import ProshopSettingsContainer from './components/Proshop/ProshopSettingsContainer.jsx'
import ConfigMembershipSyncContainer from './views/admin/ConfigMembershipSyncContainer.jsx'
import DayReservationsContainer from './views/admin/DayReservationsContainer.jsx'
import SyncIcon from '@mui/icons-material/Sync'
import WeekPlannerCourtsContainer from './views/admin/WeekPlannerCourtsContainer.jsx'
import EventTicketsContainer from './views/admin/EventTicketsContainer.jsx'
import AffiliateCampaignsContainer from './views/admin/AffiliateCampaignsContainer.jsx'
import AffiliatePartnersContainer from './views/admin/AffiliatePartnersContainer.jsx'

import MessagingListsContainer from './views/admin/MessagingListsContainer.jsx'
import MessagingListsMessagesContainer from './views/admin/MessagingListsMessagesContainer.jsx'
import SurveysContainer from './views/admin/SurveysContainer.jsx'
import SurveyResultsContainer from './views/admin/SurveyResultsContainer.jsx'
import NewsContainer from './views/admin/NewsContainer.jsx'

import CoachingGroupContainer from './views/admin/CoachingGroupContainer.jsx'
import CoachingEntriesContainer from './views/admin/CoachingEntriesContainer.jsx'
import CoachingSeasonSettingsContainer from './views/admin/CoachingSeasonSettingsContainer.jsx'
import CoachingGeneralSettingsContainer from './views/admin/CoachingGeneralSettingsContainer.jsx'

import VenuepageContainer from './views/admin/VenuepageContainer.jsx'
import CintoiaEventsContainer from './views/common/CintoiaEventsContainer.jsx'

const PRODUCT_PILOT_CUSTOMERS = [
  'ramu-Tq22jQlBPgbsiJ26bNxg',
  'testilanmailapelikeskus-sgaVLykN',
  'tali-2GjtFLost8pDf0dWwmNc',
  'kerttula-asfji2300203',
  'nokiatennis-1tmwvtS3',
  'evs-4FD8m7rCa7wOuCADvzZZ',
  'valkeakoskentennistuki-22MbYNtH',
  'mandatumcenter-hLWUQwcJ'
]

const PROSHOP_PILOT_CUSTOMERS = [
  'ramu-Tq22jQlBPgbsiJ26bNxg',
  'testilanmailapelikeskus-sgaVLykN',
  'monniklubi-8duqSkYj'
]

const SNAPPOS_CUSTOMERS = [
  'ramu-Tq22jQlBPgbsiJ26bNxg',
  'impivaarantenniskeskus-ejwHU2iX',
  'testilanmailapelikeskus-sgaVLykN',
  'lahdentennisjasquash-zLco5rzk',
  'evs-4FD8m7rCa7wOuCADvzZZ',
  'nallisport-20FA1VH3',
  'varistontenniskeskus-TmA6mQms',
]

const MAILMARKETING_PILOT_CUSTOMERS = [
  'ramu-Tq22jQlBPgbsiJ26bNxg',
  'nallisport-20FA1VH3',
  'testilanmailapelikeskus-sgaVLykN',
]

const routes = [
  {
    path: '/calendar',
    name: 'Kalenteri',
    symbol: 'calendar_view_day',
    icon: 'nc-icon nc-layout-11',
    component: AdminCourtsContainer,
    layout: '/admin',
  },
  {
    path: '/teamweekplanner',
    name: 'Viikkokalenteri',
    symbol: 'calendar_view_week',
    icon: 'nc-icon nc-layout-11',
    component: WeekPlannerCourtsContainer,
    layout: '/admin',
  },
  {
    // Day resources booked per calendar day (docs/features/day-resources.md). Enabled per venue with
    // venuemanagerfeatures limitedmenus.dayreservations.
    path: '/dayreservations',
    name: 'Päivävaraukset',
    symbol: 'event_available',
    icon: 'nc-icon nc-calendar-60',
    component: DayReservationsContainer,
    layout: '/admin',
    limited: true,
  },
  {
    path: '/activities',
    name: 'Aktiviteetit',
    symbol: 'sports_tennis',
    icon: 'nc-icon nc-spaceship',
    collapse: true,
    state: 'activitiesCollapse',
    layout: '/admin',
    views: [
      {
        path: '/activities/list',
        name: 'Lista',
        icon: 'nc-icon nc-bullet-list-67',
        component: ActivitiesContainer,
        layout: '/admin',
      },
      {
        path: '/activities/calendar',
        name: 'Kalenteri',
        icon: 'nc-icon nc-calendar-60',
        component: ActivitiesCalendarContainer,
        layout: '/admin',
      },
      {
        // recurring series, incl. drafts that have no occurrences yet (docs/features/recurring-activities.md)
        path: '/activities/recurring',
        name: 'Toistuvat',
        icon: 'nc-icon nc-refresh-69',
        component: RecurringActivitiesContainer,
        layout: '/admin',
      },
      {
        // activity templates, dropped onto the activity calendar (docs/features/activity-templates.md)
        path: '/activities/templates',
        name: 'Pohjat',
        icon: 'nc-icon nc-single-copy-04',
        component: ActivityTemplatesContainer,
        layout: '/admin',
      },
    ],
  },
  // {
  //   path: '/dndcalendar',
  //   name: 'DND',
  //   icon: 'nc-icon nc-layout-11',
  //   component: AdminCourtsDNDContainer,
  //   layout: '/admin',
  // },
  // {
  //   path: '/customers',
  //   collapse: true,
  //   name: 'Asiakkaat',
  //   icon: 'nc-icon nc-single-02',
  //   state: 'customersCollapse',
  //   views: [
  // {
  //   divider: true,
  //   label: 'Asiakkaat',
  //   layout: '/admin',
  // },
  {
    path: '/customers/persons',
    name: 'Henkilöt',
    symbol: 'person',
    icon: 'nc-icon nc-circle-10',
    component: CustomerPersonSearchContainer,
    layout: '/admin',
  },
  {
    path: '/customers/organizations',
    name: 'Yritykset',
    symbol: 'apartment',
    icon: 'nc-icon nc-bank',
    component: CustomerOrganisationContainer,
    layout: '/admin',
  },
  {
    path: '/recurrents',
    name: 'Vakiovuorot',
    symbol: 'event_repeat',
    icon: 'nc-icon nc-layout-11',
    component: RecurrentCourtsContainer,
    layout: '/admin',
  },
  {
    path: '/recurring',
    name: 'Vakiot',
    symbol: 'autorenew',
    collapse: true,
    icon: 'nc-icon nc-layout-11',
    iconcomponent: RepeatIcon,
    state: 'recurringCollapse',
    layout: '/admin',
    limited: true,
    views: [
      {
        path: '/recurring/reservations',
        name: 'Vuorot',
        icon: 'nc-icon nc-layout-11',
        component: RecurrentCourtsContainer,
        iconcomponent: DateRangeIcon,
        layout: '/admin',
      },
      {
        path: '/recurring/sales',
        name: 'Myyntikampanjat',
        icon: 'nc-icon nc-paper',
        component: RecurringSalesContainer,
        iconcomponent: NewReleasesIcon,
        layout: '/admin',
      },
      {
        path: '/recurring/inquiries',
        name: 'Kyselyt',
        icon: 'nc-icon nc-paper',
        component: RecurringInquiriesContainer,
        iconcomponent: QuestionAnswerIcon,
        layout: '/admin',
      },
      {
        path: '/recurring/pricing',
        name: 'Myynnin hinnastot',
        icon: 'nc-icon nc-paper',
        iconcomponent: EuroIcon,
        component: RecurringSalePricingCalendarContainer,
        layout: '/admin',
      },
      {
        path: '/recurring/confirmation',
        name: 'Ostot/Vahvistukset',
        icon: 'nc-icon nc-paper',
        component: TBDContainer,
        iconcomponent: DoneIcon,
        layout: '/admin',
      },
      {
        path: '/recurring/contracts',
        name: 'Sopimukset',
        icon: 'nc-icon nc-paper',
        component: ContractsContainer,
        iconcomponent: GavelIcon,
        layout: '/admin',
      },
      {
        path: '/recurring/contracttemplates',
        name: 'Sopimusmallit',
        icon: 'nc-icon nc-paper',
        component: ContractTemplatesContainer,
        layout: '/admin',
      },
      {
        path: '/recurring/contractterms',
        name: 'Sopimusehdot (vanha)',
        icon: 'nc-icon nc-paper',
        component: ConfigRecurringContractTerms,
        layout: '/admin',
      },
    ],
    customers: [
      'ramu-Tq22jQlBPgbsiJ26bNxg',
      'testilanmailapelikeskus-sgaVLykN',
    ],
  },
  // Joukkuevaraukset (sarjaottelut). docs/features/teams.md.
  //
  // The gate is read off whichever route carries `limited`, and that is this group, not its
  // children - they have no `limited` of their own, so they pass the filter unconditionally
  // (Sidebar.jsx:93-104, and :172 for the child pass). The whole group therefore hangs on the
  // single key `limitedmenus.teams`; the child paths need no key, and Phases C-D add none.
  {
    path: '/teams',
    name: 'Joukkueet',
    symbol: 'groups',
    collapse: true,
    icon: 'nc-icon nc-single-02',
    iconcomponent: GroupsIcon,
    state: 'teamsCollapse',
    layout: '/admin',
    limited: true,
    views: [
      {
        path: '/teams/seasons',
        name: 'Kaudet',
        icon: 'nc-icon nc-calendar-60',
        component: TeamSeasonCalendarContainer,
        iconcomponent: DateRangeIcon,
        layout: '/admin',
      },
      {
        path: '/teams/formats',
        name: 'Ottelumuodot',
        icon: 'nc-icon nc-bullet-list-67',
        component: TeamFormatsContainer,
        iconcomponent: TuneIcon,
        layout: '/admin',
      },
      {
        path: '/teams/teams',
        name: 'Joukkueet',
        icon: 'nc-icon nc-single-02',
        component: TeamsContainer,
        iconcomponent: GroupsIcon,
        layout: '/admin',
      },
      {
        path: '/teams/ties',
        name: 'Kohtaamiset',
        icon: 'nc-icon nc-calendar-60',
        component: TeamTiesContainer,
        iconcomponent: EventAvailableIcon,
        layout: '/admin',
      },
    ],
  },
  {
    path: '/invoice',
    name: 'Laskutus',
    symbol: 'receipt_long',
    collapse: true,
    icon: 'nc-icon nc-money-coins',
    state: 'invoicingCollapse',
    layout: '/admin',
    views: [
      {
        path: '/invoicing',
        name: 'Laskutettavaa',
        icon: 'nc-icon nc-money-coins',
        component: InvoicingContainer,
        layout: '/admin',
      },
      {
        path: '/invoices',
        name: 'Laskut',
        icon: 'nc-icon nc-money-coins',
        component: InvoicesContainer,
        layout: '/admin',
      },
    ],
  },
    {
    path: '/reporting',
    name: 'Raportointi',
    symbol: 'monitoring',
    icon: 'nc-icon nc-chart-pie-36',
    layout: '/admin',
    collapse: true,
    state: 'reportingCollapse',
    views: [
      {
        path: '/reporting/reports',
        name: 'Raportit',
        icon: 'nc-icon nc-bullet-list-67',
        component: ReportingContainer,
        layout: '/admin',
      },
      {
        path: '/reporting/weeklysummary',
        name: 'Viikkokooste',
        icon: 'nc-icon nc-chart-bar-32',
        component: WeeklySummaryContainer,
        layout: '/admin',
      },
      {
        path: '/reporting/monthlysummary',
        name: 'Kuukausikooste',
        icon: 'nc-icon nc-calendar-60',
        component: MonthlySummaryContainer,
        layout: '/admin',
      },
    ],
  },
  {
    divider: true,
    layout: '/admin',
  },
    {
    path: '/messaging',
    name: 'Asiakasviestintä',
    symbol: 'chat',
    icon: 'nc-icon nc-chat-33',
    layout: '/admin',
    collapse: true,
    limited: true,
    state: 'messagingCollapse',
    views: [
      {
        path: '/messaging/audiences',
        name: 'Listat',
        icon: 'nc-icon nc-bullet-list-67',
        component: MessagingListsContainer,
        layout: '/admin',
      },
      {
        path: '/messaging/messages',
        name: 'Viestit',
        icon: 'nc-icon nc-email-85',
        component: MessagingListsMessagesContainer,
        layout: '/admin',
      },
      {
        path: '/messaging/surveys',
        name: 'Kyselyt',
        icon: 'nc-icon nc-paper',
        component: SurveysContainer,
        layout: '/admin',
      },
      {
        path: '/messaging/surveys/:surveyId/results',
        name: 'Kyselytulokset',
        icon: 'nc-icon nc-chart-bar-32',
        component: SurveyResultsContainer,
        layout: '/admin',
        invisible: true,
      },
      {
        path: '/messaging/news',
        name: 'Uutiset',
        icon: 'nc-icon nc-single-copy-04',
        component: NewsContainer,
        layout: '/admin',
      },
      // {
      //   path: '/messaging/templates',
      //   name: 'Pohjat',
      //   icon: 'nc-icon nc-single-copy-04',
      //   component: TBDContainer,
      //   layout: '/admin',
      // },
      // {
      //   path: '/messaging/automation',
      //   name: 'Automaatiot',
      //   icon: 'nc-icon nc-settings-gear-65',
      //   component: TBDContainer,
      //   layout: '/admin',
      // },
      // {
      //   path: '/messaging/statistics',
      //   name: 'Tilastot',
      //   icon: 'nc-icon nc-chart-bar-32',
      //   component: TBDContainer,
      //   layout: '/admin',
      // }
    ],
  },
  {
    path: '/notifications',
    name: 'Ilmoitukset',
    symbol: 'campaign',
    collapse: true,
    icon: 'nc-icon nc-bell-55',
    state: 'notificationsCollapse',
    layout: '/admin',
    views: [
      {
        path: '/banners',
        name: 'Bannerit',
        icon: 'nc-icon nc-image',
        component: BannersContainer,
        layout: '/admin',
      },
      {
        path: '/textbanners',
        name: 'Tekstibannerit',
        icon: 'nc-icon nc-paper',
        component: TextBannersContainer,
        layout: '/admin',
      },
      {
        path: '/infotexts',
        name: 'Kassa Infotekstit',
        icon: 'nc-icon nc-bell-55',
        component: ConfigInfoTexts,
        layout: '/admin',
      },
    ],
  },
  // {
  //   path: '/customers/live',
  //   name: 'Live',
  //   icon: 'nc-icon nc-sound-wave',
  //   component: CustomersLiveContainer,
  //   layout: '/admin',
  // },
  //   ],
  //   layout: '/admin',
  // },
  {
    // Tiedustelut of every type (docs/features/inquiries.md). Limited: a venue gets the menu
    // entry with limitedmenus.inquiries, once a partner sends it inquiries.
    path: '/inquiries',
    name: 'Tiedustelut',
    symbol: 'contact_mail',
    icon: 'nc-icon nc-email-85',
    component: InquiriesContainer,
    layout: '/admin',
    limited: true,
    badge: 'inquiries',
  },
  {
    divider: true,
    layout: '/admin',
  },

  {
    path: '/member',
    name: 'Jäsenyydet',
    symbol: 'card_membership',
    collapse: true,
    icon: 'nc-icon nc-badge',
    state: 'memberCollapse',
    layout: '/admin',
    views: [
      {
        path: '/memberships',
        name: 'Jäsentyypit',
        icon: 'nc-icon nc-badge',
        component: MembershipsContainer,
        layout: '/admin',
      },
      {
        path: '/membershippricings',
        name: 'Jäsenhinnoittelu',
        icon: 'nc-icon nc-money-coins',
        component: MembershipPricingCalendarContainer,
        layout: '/admin',
      },
      {
        path: '/membershiplists',
        name: 'Jäsenten listaus',
        icon: 'nc-icon nc-paper',
        component: MembershipListContainer,
        layout: '/admin',
      }
    ],
  },
  {
    path: '/giftcodes',
    name: 'Kampanjat',
    symbol: 'sell',
    collapse: true,
    icon: 'nc-icon nc-tag-content',
    state: 'giftcodeCollapse',
    layout: '/admin',
    views: [
      {
        path: '/giftcodes',
        name: 'Etukoodit',
        icon: 'nc-icon nc-tag-content',
        component: GiftcodeContainer,
        layout: '/admin',
      },
      {
        path: '/giftcodeppricings',
        name: 'Etukoodien hinnoittelu',
        icon: 'nc-icon nc-money-coins',
        component: GiftcodePricingCalendarContainer,
        layout: '/admin',
      },
    ],
  },
{
    path: '/cards',
    name: 'Sarjakortit',
    collapse: true,
    icon: 'nc-icon nc-badge',
    iconcomponent: CreditCardIcon,
    layout: '/admin',
    state: 'cardsCollapse',
    views: [
      {
        path: '/benefitcards',
        name: 'Aktiviteetit',
        icon: 'nc-icon nc-badge',
        iconcomponent: FontDownloadIcon,
        component: BenefitCardsContainer,
        layout: '/admin',
      },
      {
        path: '/reservationcards',
        name: 'Varaukset',
        icon: 'nc-icon nc-badge',
        iconcomponent: TodayIcon,
        component: ReservationBenefitCardsContainer,
        layout: '/admin',
      },
      {
        path: '/rescardsschedules',
        name: 'Varauskorttien ajat',
        icon: 'nc-icon nc-badge',
        iconcomponent: ScheduleIcon,
        component: ReservationBenefitCardCalendarContainer,
        layout: '/admin',
      },
      {
        // Arvokortti, not lahjakortti: 'Lahjakortti' already names three other things - the
        // gift-certificate payment mark, the giftcode discount code, and a dead giftcards
        // stub in the functions repo. See docs/features/valuecards.md.
        //
        // limited: true is deliberate. This route was commented out since the initial import
        // and carried no gating, so enabling it as written would have shown an unfinished
        // feature to every admin in every venue. Key is the path with slashes stripped:
        // venuemanagerfeatures/{cid}.limitedmenus.valuecards
        path: '/valuecards',
        name: 'Arvokortit',
        icon: 'nc-icon nc-money-coins',
        iconcomponent: CardGiftcardIcon,
        component: ValueCardsContainer,
        layout: '/admin',
        limited: true,
      },
      {
        path: '/benefitcardslist',
        name: 'Korttilistaus',
        icon: 'nc-icon nc-badge',
        iconcomponent: FontDownloadIcon,
        component: BenefitCardListsContainer,
        layout: '/admin',
      }
    ],
  },
  {
    path: '/shareregistry',
    name: 'Osakerekisteri',
    symbol: 'account_balance',
    icon: 'nc-icon nc-paper',
    collapse: true,
    state: 'shareregistryCollapse',
    layout: '/admin',
    views: [
      {
        path: '/shareregistry/registry',
        name: 'Rekisteri',
        icon: 'nc-icon nc-paper',
        component: ShareRegistryContainer,
        layout: '/admin',
      },
      {
        path: '/shareregistry/transactions',
        name: 'Tapahtumat',
        icon: 'nc-icon nc-bullet-list-67',
        component: ShareRegistryTransactionsContainer,
        layout: '/admin',
      },
      {
        path: '/shareregistry/settings',
        name: 'Asetukset',
        icon: 'nc-icon nc-settings-gear-65',
        component: ShareRegistrySettingsContainer,
        layout: '/admin',
      },
    ],
  },
  {
    divider: true,
    layout: '/admin',
  },
  {
    path: '/reservationproducts',
    name: 'Lisätuotteet',
    symbol: 'add_shopping_cart',
    icon: 'nc-icon nc-cart-simple',
    component: ReservationExtrasContainer,
    layout: '/admin',
    betatext: '',
    beta: true,
  },
  {
    path: '/shop/products',
    name: 'Tuotteet (laskulle)',
    symbol: 'inventory_2',
    icon: 'nc-icon nc-bag-16',
    component: ShopProductsContainer,
    layout: '/admin',
    betatext: '',
    beta: true,
    limited: true
  },
  {
    path: '/tickets',
    name: 'Tapahtumaliput',
    symbol: 'local_activity',
    icon: 'nc-icon nc-spaceship',
    component: EventTicketsContainer,
    layout: '/admin',
    betatext: '',
    beta: false,
  },
  {
    path: '/affiliate',
    name: 'Kumppanimyynti',
    symbol: 'handshake',
    collapse: true,
    icon: 'nc-icon nc-vector',
    state: 'affiliateCollapse',
    layout: '/admin',
    betatext: '',
    beta: true,
    limited: true,
    views: [
      {
        path: '/affiliate/campaigns',
        name: 'Kampanjat',
        icon: 'nc-icon nc-bullet-list-67',
        component: AffiliateCampaignsContainer,
        layout: '/admin',
      },
      {
        path: '/affiliate/partners',
        name: 'Kumppanit',
        icon: 'nc-icon nc-single-02',
        component: AffiliatePartnersContainer,
        layout: '/admin',
      },
    ],
  },
  {
    path: '/proshop',
    name: 'Proshop',
    symbol: 'storefront',
    collapse: true,
    icon: 'nc-icon nc-shop',
    layout: '/admin',
    betatext: 'testi',
    state: 'proshopCollapse',
    beta: true,
    limited: true,
    views: [
      {
        path: '/proshop/products',
        name: 'Tuotteet',
        icon: 'nc-icon nc-bag-16',
        component: ProshopContainer,
        betatext: 'testi',
        beta: true,
        layout: '/admin',
      },
      {
        path: '/proshop/orders',
        name: 'Tilaukset',
        icon: 'nc-icon nc-basket',
        component: ProshopOrdersContainer,
        betatext: 'testi',
        beta: true,
        layout: '/admin',
      },
    ],
  },
    {
    divider: true,
    layout: '/admin',
  },

  {
    path: '/coaching',
    name: 'Valmennus',
    symbol: 'sports',
    icon: 'nc-icon nc-paper',
    layout: '/admin',
    collapse: true,
    state: 'coachingCollapse',
    limited: true,
    customers: ['ramu-Tq22jQlBPgbsiJ26bNxg'],
    views: [
      {
        path: '/coaching/groups',
        name: 'Ryhmät',
        icon: 'nc-icon nc-circle-10',
        component: CoachingGroupContainer,
        layout: '/admin',
      },
      {
        path: '/coaching/entries',
        name: 'Ilmoittautumiset',
        icon: 'nc-icon nc-circle-10',
        component: CoachingEntriesContainer,
        layout: '/admin',
      },
      {
        path: '/coaching/seasonsettings',
        name: 'Kausiasetukset',
        icon: 'nc-icon nc-settings-gear-65',
        component: CoachingSeasonSettingsContainer,
        layout: '/admin',
      },
      {
        path: '/coaching/coaches',
        name: 'Valmentajat',
        icon: 'nc-icon nc-settings-gear-65',
        component: CoachingGeneralSettingsContainer,
        layout: '/admin',
      },
      {
        path: '/coaching/roles',
        name: 'Muut roolit',
        icon: 'nc-icon nc-settings-gear-65',
        component: CoachingGeneralSettingsContainer,
        layout: '/admin',
      },
      {
        path: '/coaching/settings',
        name: 'Asetukset',
        icon: 'nc-icon nc-settings-gear-65',
        component: CoachingGeneralSettingsContainer,
        layout: '/admin',
      }
    ],
  },


  {
    path: '/buildingmainenance',
    name: 'Kiinteistöhuolto',
    symbol: 'build',
    icon: 'nc-icon nc-settings',
    collapse: true,
    iconcomponent: ApartmentIcon,
    layout: '/admin',
    state: 'buildingmaintenanceCollapse',
    views: [
      {
        path: '/mainenancetickets',
        name: 'Tiketit',
        icon: 'nc-icon nc-settings',
        component: BuildingMaintenanceTicketsContainer,
        iconcomponent: BuildIcon,
        layout: '/admin',
      },
      {
        path: '/maintenanceplan',
        name: 'Huoltosuunnitelma',
        icon: 'nc-icon nc-settings',
        component: BuildingMaintenancePlanContainer,
        iconcomponent: BuildIcon,
        layout: '/admin',
      },
      //,
      // {
      //   path: '/executions',
      //   name: 'Puhtaanapito',
      //   icon: 'nc-icon nc-settings',
      //   component: BuildingMaintenanceContainer,
      //   serviceIcon: TarmoIcon,
      //   iconcomponent: RestoreFromTrashIcon,
      //   layout: '/admin',
      // },
      // {
      //   path: '/buildingorders',
      //   name: 'Tavaratilaukset',
      //   icon: 'nc-icon nc-settings',
      //   serviceIcon: TarmoIcon,
      //   component: BuildingMaintenanceProductsContainer,
      //   iconcomponent: ShoppingBasketIcon,
      //   layout: '/admin',
      // },
      // {
      //   path: '/buildingadmin',
      //   name: 'Tehtävähallinta',
      //   icon: 'nc-icon nc-settings',
      //   serviceIcon: TarmoIcon,
      //   component: BuildingMaintenanceAdminContainer,
      //   iconcomponent: TuneIcon,
      //   layout: '/admin',
      // },
    ],
  
  },
  // {
  //   path: '/partners',
  //   name: 'Partnerit',
  //   icon: 'nc-icon nc-spaceship',
  //   component: PartnerContainer,
  //   layout: '/admin',
  // },
  // {
  //   path: '/shop',
  //   name: 'Shop',
  //   icon: 'nc-icon nc-shop',
  //   collapse: true,
  //   layout: '/admin',
  //   state: 'shopCollapse',
  //   views: [
  //     {
  //       path: '/shop/products',
  //       name: 'Tuotteet',
  //       icon: 'nc-icon nc-bag-16',
  //       component: ProductsContainer,
  //       properties: { releases: BACKEND_RELEASES },
  //       layout: '/admin',
  //     },
  //     {
  //       path: '/shop/orders',
  //       name: 'Tilaukset',
  //       icon: 'nc-icon nc-basket',
  //       component: TBDContainer,
  //       properties: { releases: BACKEND_RELEASES },
  //       layout: '/admin',
  //     }
  //   ]
  // },
  {
    path: '/snappos',
    name: 'PikaKassa',
    symbol: 'point_of_sale',
    iconcomponent: KeyboardIcon,
    component: SimplePosContainer,
    layout: '/admin',
    limited: true,
  },

  {
    path: '/medialibrary',
    name: 'Mediakirjasto',
    symbol: 'photo_library',
    icon: 'nc-icon nc-album-2',
    component: MediaLibraryContainer,
    layout: '/admin',
  },
  // {
  //   path: '/automationmarketing',
  //   name: 'Markkinoitointiautomaatio',
  //   icon: 'nc-icon nc-atom',
  //   component: AutomationMarketingContainer,
  //   layout: '/admin',
  //   betatext: '',
  //   beta: true,

  // },
  {
    path: '/leagues',
    name: 'Hallisarjat',
    symbol: 'emoji_events',
    icon: 'nc-icon nc-trophy',
    component: TBDContainer,
    layout: '/admin',
    limited: true,
  },
  {
    path: '/config',
    name: 'Asetukset',
    symbol: 'settings',
    collapse: true,
    icon: 'nc-icon nc-settings',
    iconcomponent: SettingsOutlinedIcon,
    state: 'configCollapse',
    views: [
      // Provisional home. This is a free-times viewer, not really a setting - it lives here
      // because it needed somewhere gated to land. limitedmenus key: configcustomertimes.
      {
        path: '/config/customertimes',
        name: 'Myytävät ajat',
        icon: 'nc-icon nc-watch-time',
        iconcomponent: EventAvailableOutlinedIcon,
        component: CustomerTimesCalendarContainer,
        layout: '/admin',
        limited: true,
      },
      {
        path: '/venuepage',
        name: 'Paikan tiedot',
        icon: 'nc-icon nc-bank',
        component: VenuepageContainer,
        iconcomponent: BusinessOutlinedIcon,
        layout: '/admin',
      },
      {
        path: '/resources',
        name: 'Resurssit',
        icon: 'nc-icon nc-single-copy-04',
        component: ResourcesContainer,
        layout: '/admin',
      },
      {
        path: '/users',
        name: 'Käyttäjät',
        icon: 'nc-icon nc-single-02',
        component: CustomerUserContainer,
        layout: '/admin',
      },
      {
        path: '/pricing',
        name: 'Hinnoittelu',
        icon: 'nc-icon nc-money-coins',
        component: PricingCalendarContainer,
        layout: '/admin',
      },
      {
        path: '/terms',
        name: 'Varausehdot',
        icon: 'nc-icon nc-paper',
        component: ConfigTerms,
        layout: '/admin',
      },
      {
        path: '/config/customerviewability',
        name: 'Asiakkaan menut',
        icon: 'nc-icon nc-spaceship',
        component: ConfigCustomerViewability,
        layout: '/admin',
      },
      // {
      //   path: '/benefitcards',
      //   name: 'Sarjakortit',
      //   icon: 'nc-icon nc-badge',
      //   component: BenefitCardsContainer,
      //   layout: '/admin',
      // },

      {
        path: '/config/resourcecategories',
        name: 'Resurssiluokat',
        icon: 'nc-icon nc-bullet-list-67',
        component: ConfigResourceCategoriesContainer,
        layout: '/admin',
      },
      {
        path: '/config/sportsandactivitytypes',
        name: 'Lajit ja aktiviteettityypit',
        icon: 'nc-icon nc-trophy',
        component: ConfigSportsAndActivityTypes,
        layout: '/admin',
      },
      {
        path: '/config/openingtimes',
        name: 'Aukioloajat',
        icon: 'nc-icon nc-sun-fog-29',
        component: ConfigOpeningTimes,
        layout: '/admin',
      },
      {
        path: '/config/providers',
        name: 'Kumppanit',
        iconcomponent: BusinessOutlinedIcon,
        component: ProvidersContainer,
        layout: '/admin',
      },
      // }
      // {
      //   path: '/config/resourceconfigs',
      //   name: 'Resurssin asetukset',
      //   icon: 'nc-icon nc-settings-gear-65',
      //   component: ConfigResourceConfigsContainer,
      //   layout: '/admin',
      // },
      {
        path: '/config/colorconfigs',
        name: 'Kalenterin väritys',
        icon: 'nc-icon nc-tag-content',
        component: ConfigColorsContainer,
        layout: '/admin',
      },
      {
        path: '/config/confirmtemplates',
        name: 'Viestiasetukset',
        icon: 'nc-icon nc-single-copy-04',
        component: ConfigMessageTemplates,
        layout: '/admin',
      },
      {
        path: '/config/ticketadmin',
        name: 'Huollon tiketit',
        icon: 'nc-icon nc-settings',
        component: BuildingMaintenanceTicketsSettingsContainer,
        iconcomponent: TuneIcon,
        layout: '/admin',
      },
      {
        path: '/config/proshop',
        name: 'Proshop',
        icon: 'nc-icon nc-settings',
        component: ProshopSettingsContainer,
        iconcomponent: TuneIcon,
        layout: '/admin',
        limited: true
      },
      {
        path: '/config/membershipsync',
        name: 'Jäsenyyksien synkronointi',
        iconcomponent: SyncIcon,
        component: ConfigMembershipSyncContainer,
        layout: '/admin',
      },

      // {
      //   path: '/config/remindertemplates',
      //   name: 'Muistutusviestit',
      //   icon: 'nc-icon nc-single-copy-04',
      //   component: ConfigReminderTemplates,
      //   layout: '/admin',
      // },
      // {
      //   path: '/config/infotexts',
      //   name: 'Infoviestit',
      //   icon: 'nc-icon nc-single-copy-04',
      //   component: ConfigInfoTexts,
      //   layout: '/admin',
      // },

      // {
      //   path: '/config/customerextras',
      //   name: 'Asiakaslisätiedot',
      //   icon: 'nc-icon nc-single-copy-04',
      //   component: ConfigCustomerExtradata,
      //   layout: '/admin'
      // }
    ],
    layout: '/admin',
  },
  // {
  //   path: '/groups',
  //   name: 'Ryhmät',
  //   icon: 'nc-icon nc-circle-10',
  //   component: TBDContainer,
  //   properties: { releases: BACKEND_RELEASES },
  //   layout: '/admin',
  // },
  // {
  //   path: '/happenings',
  //   name: 'Tapahtumat',
  //   icon: 'nc-icon nc-pin-3',
  //   component: TBDContainer,
  //   properties: { releases: BACKEND_RELEASES },
  //   layout: '/admin',
  // },
  // {
  //   path: '/billing',
  //   name: 'Laskutus',
  //   icon: 'nc-icon nc-paper',
  //   component: TBDContainer,
  //   properties: { releases: BACKEND_RELEASES },
  //   layout: '/admin',
  // },
  // {
  //   path: '/reports',
  //   name: 'Raportit',
  //   icon: 'nc-icon nc-chart-pie-36',
  //   component: TBDContainer,
  //   properties: { releases: BACKEND_RELEASES },
  //   layout: '/admin',
  // },
  // {
  //   path: '/messaging',
  //   name: 'Viestintä',
  //   icon: 'nc-icon nc-chat-33',
  //   component: TBDContainer,
  //   properties: { releases: BACKEND_RELEASES },
  //   layout: '/admin',
  // },
  // {
  //   path: '/main',
  //   name: 'Dev Timeline',
  //   icon: 'nc-icon nc-atom',
  //   component: DevHistory,
  //   properties: { releasehistory: RELEASE_HISTORY, backendreleases: BACKEND_RELEASES, mobilereleases: MOBILE_RELEASES },
  //   layout: '/admin',
  // },

  {
    path: '/courts',
    name: 'Kentät',
    icon: 'nc-icon nc-layout-11',
    component: MainContainer,
    layout: '/cashiers',
  },
  {
    path: '/customers',
    name: 'Asiakkaat',
    icon: 'nc-icon nc-single-02',
    component: PersonsContrainer,
    layout: '/cashiers',
  },
  {
    path: '/products',
    name: 'Tuotteet',
    icon: 'nc-icon nc-shop',
    component: CashierCourtsContainer,
    layout: '/cashiers',
  },
  {
    path: '/next',
    name: 'Seuraavat vapaat',
    icon: 'nc-icon nc-satisfied',
    component: CashierCourtsContainer,
    layout: '/cashiers',
  },
  {
    path: '/happenings',
    name: 'Tapahtumat',
    icon: 'nc-icon nc-key-25',
    component: CashierCourtsContainer,
    layout: '/cashiers',
  },
  {
    path: '/messages',
    name: 'Viestit',
    icon: 'nc-icon nc-chat-33',
    component: CashierCourtsContainer,
    layout: '/cashiers',
  },
  {
    path: '/lights',
    name: 'Valot',
    symbol: 'lightbulb',
    icon: 'nc-icon nc-bulb-63',
    component: LightsForce,
    layout: '/admin',
    limited: true,
    customers: ['ramu-Tq22jQlBPgbsiJ26bNxg', 'lahdentennisjasquash-zLco5rzk'],
  },
  {
    // Cintoia's webinars and podcasts, the same for every venue (docs/features/cintoia-events.md)
    path: '/cintoiaevents',
    name: 'Cintoia Events',
    symbol: 'podcasts',
    component: CintoiaEventsContainer,
    layout: '/admin',
    badge: 'events',
  },
  {
    path: '/logout',
    name: 'Logout',
    icon: 'nc-icon nc-button-power',
    component: Logout,
    layout: '/admin',
    // Reached from the sidebar account card (Kirjaudu ulos), not from the menu.
    invisible: true,
  },
  {
    path: '/calendar',
    name: 'Kalenteri',
    symbol: 'calendar_view_day',
    icon: 'nc-icon nc-layout-11',
    component: AdminCourtsContainer,
    layout: '/cashier',
  },
  {
    path: '/customers/persons',
    name: 'Henkilöt',
    symbol: 'person',
    icon: 'nc-icon nc-circle-10',
    component: CustomerPersonSearchContainer,
    layout: '/cashier',
  },
  {
    path: '/customers/organizations',
    name: 'Yritykset',
    symbol: 'apartment',
    icon: 'nc-icon nc-bank',
    component: CustomerOrganisationContainer,
    layout: '/cashier',
    // Cashiers can look organisations up but not add or edit them.
    properties: { readOnly: true },
  },
  {
    path: '/snappos',
    name: 'PikaKassa',
    symbol: 'point_of_sale',
    iconcomponent: KeyboardIcon,
    component: SimplePosContainer,
    layout: '/cashier',
    limited: true,
    customers: [
      'ramu-Tq22jQlBPgbsiJ26bNxg',
      'impivaarantenniskeskus-ejwHU2iX',
      'testilanmailapelikeskus-sgaVLykN',
    ],
  },
  {
    path: '/unpaid',
    name: 'Maksamattomat',
    symbol: 'money_off',
    icon: 'nc-icon nc-money-coins',
    component: UnpaidContainer,
    layout: '/cashier',
  },
  {
    path: '/activities',
    name: 'Aktiviteetit',
    symbol: 'sports_tennis',
    icon: 'nc-icon nc-spaceship',
    component: ActivitiesContainer,
    layout: '/cashier',
  },
  {
    path: '/lights',
    name: 'Valot',
    symbol: 'lightbulb',
    icon: 'nc-icon nc-bulb-63',
    component: LightsForce,
    layout: '/cashier',
    limited: true,
    customers: ['ramu-Tq22jQlBPgbsiJ26bNxg', 'lahdentennisjasquash-zLco5rzk'],
  },
  {
    // Cintoia's webinars and podcasts, the same for every venue (docs/features/cintoia-events.md)
    path: '/cintoiaevents',
    name: 'Cintoia Events',
    symbol: 'podcasts',
    component: CintoiaEventsContainer,
    layout: '/cashier',
    badge: 'events',
  },
  {
    path: '/logout',
    name: 'Logout',
    icon: 'nc-icon nc-button-power',
    component: Logout,
    layout: '/cashier',
    // Reached from the sidebar account card (Kirjaudu ulos), not from the menu.
    invisible: true,
  },

  {
    path: '/calendar',
    name: 'Kalenteri',
    symbol: 'calendar_view_day',
    icon: 'nc-icon nc-layout-11',
    component: AdminCourtsContainer,
    layout: '/partner',
  },
  {
    // Cintoia's webinars and podcasts, the same for every venue (docs/features/cintoia-events.md)
    path: '/cintoiaevents',
    name: 'Cintoia Events',
    symbol: 'podcasts',
    component: CintoiaEventsContainer,
    layout: '/partner',
    badge: 'events',
  },
  {
    path: '/logout',
    name: 'Logout',
    icon: 'nc-icon nc-button-power',
    component: Logout,
    layout: '/partner',
    // Reached from the sidebar account card (Kirjaudu ulos), not from the menu.
    invisible: true,
  },
  {
    path: '/calendar',
    name: 'Kalenteri',
    symbol: 'calendar_view_day',
    icon: 'nc-icon nc-layout-11',
    component: AdminCourtsContainer,
    layout: '/cooperative',
  },
  {
    // Cintoia's webinars and podcasts, the same for every venue (docs/features/cintoia-events.md)
    path: '/cintoiaevents',
    name: 'Cintoia Events',
    symbol: 'podcasts',
    component: CintoiaEventsContainer,
    layout: '/cooperative',
    badge: 'events',
  },
  {
    path: '/logout',
    name: 'Logout',
    icon: 'nc-icon nc-button-power',
    component: Logout,
    layout: '/cooperative',
    // Reached from the sidebar account card (Kirjaudu ulos), not from the menu.
    invisible: true,
  },
]

const getProfileRoutes = (role) => {
  if (!role) role = 'ANON'
  return routes.filter((r) => r.layout === '/' + role.toLowerCase())
}

export default getProfileRoutes

/*

*/
